module.exports = {
	"Search the video": "Search the video",
	"Explore": "Explore",
	"Print": "Print",
	"Download": "Download",
	"Share": "Share",
	"Settings": "Settings",
	"Language": "Language",
	"Interface Language": "Interface Language",
	"Transcript / Captions Language": "Transcript / Captions Language",
	"Transcript Language": "Transcript Language",
	"Captions Language": "Captions Language",
	"Show Transcript": "Show Transcript",
	"Show Captions": "Show Captions",
	"Show Heatmap": "Show Heatmap",
	"Show Speakers in Transcript": "Show Speakers in Transcript",
	"Keyword": "Keyword",
	"Keywords": "Keywords",
	"Topic": "Topic",
	"Topics": "Topics",
	"Speaker": "Speaker",
	"Speakers": "Speakers",
	"Transcript": "Transcript",
	"Previous": "Previous",
	"Next": "Next",
	"Clear": "Clear",
	"No results found": "No results found",
	"try another search or explore": "try another search or explore",
	"Share Search": "Share Search",
	"Share Time": "Share Time",
	"There is no transcript available in the selected language.": "There is no transcript available in the selected language.",
	"Show {{count}} more": "Show {{count}} more",
	"Show {{count}} more_plural": "Show {{count}} more",
	"Captions": "Captions",
	"Format": "Format",
	"There is no transcript available for the current language.": "There is no transcript available for the current language.",
	"There are no captions available for the current language.": "There are no captions available for the current language."
};


//////////////////
// WEBPACK FOOTER
// ./locale/en.json
// module id = ./locale/en.json
// module chunks = 0 1